export const THEMES = {
  vegas: {
    name: 'Vegas Classic',
    felt: '#1a472a',
    background: '#0d1b0f',
    gold: '#c9a84c',
    cream: '#f5e6c8',
  },
  midnight: {
    name: 'Midnight Blue',
    felt: '#0a1628',
    background: '#060d1a',
    gold: '#4a9eff',
    cream: '#e8f0ff',
  },
  crimson: {
    name: 'Crimson Lounge',
    felt: '#4a0a0a',
    background: '#1a0505',
    gold: '#ff6b6b',
    cream: '#ffe8e8',
  },
  ivory: {
    name: 'Ivory & Oak',
    felt: '#8b7355',
    background: '#3d2b1a',
    gold: '#d4af37',
    cream: '#faf0e6',
  },
};

export const CARD_BACKS = {
  classic: { name: 'Classic Green', color: '#1a472a', pattern: 'diamond' },
  navy: { name: 'Navy Blue', color: '#0a1628', pattern: 'crosshatch' },
  crimson: { name: 'Crimson', color: '#4a0a0a', pattern: 'diamond' },
  gold: { name: 'Gold Foil', color: '#8b6914', pattern: 'dots' },
};

export const DIFFICULTIES = {
  easy: { name: 'Easy', description: 'The Rookie — still learning the ropes', color: '#4ade80' },
  medium: { name: 'Medium', description: 'The Regular — knows all the tricks', color: '#facc15' },
  hard: { name: 'Hard', description: 'The Shark — cold, calculated, ruthless', color: '#f87171' },
};